import React from 'react';
import css from './VideoLoader.module.css';

function VideoLoader() {
  return <div className={css.loader}></div>;
}

export default VideoLoader;
